<template>
  <div class="rbz-stat-card">
    <div class="rbz-stat-card-wrapper">
      <div class="rbz-stat-card-header">
        <span class="rbz-text-large-medium rbz-stat-card-title">{{ props.title }}</span>
      </div>
      <div class="rbz-stat-card-content">
        <span class="rbz-text-h2 rbz-stat-card-content-text">{{ props.content }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconInfoSmall from 'ui-component-library/assets/icons/IconInfoSmall.vue';

interface RbzStatCardProps {
  title: string;
  content: string;
  icon: any;
  hoverText: string;
}

const props = withDefaults(defineProps<RbzStatCardProps>(), {
  title: '',
  content: '',
  icon: IconInfoSmall,
  hoverText: '',
});
</script>

<style scoped lang="scss">
@use 'sass:map';
@use 'ui-component-library/assets/styles/colors' as colors;
@use 'ui-component-library/assets/styles/main' as main;

.rbz-stat-card {
  flex: 1;
  height: 100%;
  width: 100%;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.08);
  background: map.get(colors.$colors, 'alabaster');
  border: 1px solid map.get(colors.$colors, 'gallery');
  border-radius: 4px;
  box-sizing: border-box;
  gap: 16px;
  min-height: 120px;
}

.rbz-stat-card-wrapper {
  display: flex;
  flex-direction: column;
  padding: 17px 25px;
  gap: 10px;
}

.rbz-stat-card-title {
  font-weight: 400;
  color: #313944;
  font-size: 16px;
  line-height: 20px;
}

.rbz-stat-card-content-text {
  color: #313944;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
